// extracted by mini-css-extract-plugin
export var active = "f0_fP";
export var backgroundTransform = "f0_mR";
export var dot = "f0_mP";
export var timer = "f0_mQ";